export default __webpack_public_path__ + "static/media/g11.03ad0beb.webp";